import { Literal, TranslateFunc } from '@steelbuy/ts-shared';

export const getQualityDisplayValue = (
    quality: string | undefined,
    prime: boolean | null,
    t: TranslateFunc
): string => {
    const translateFunc = t as TranslateFunc;
    if (quality) {
        return translateFunc(`domainModel:material.quality.value.${quality}` as Literal);
    }

    if (prime === null) {
        return '-';
    }
    // fallback to prime boolean for legacy data
    return translateFunc(`domainModel:material.quality.value.${prime ? 'prime' : 'nonPrime'}`);
};
